var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.3V1.2C12 0.54 11.46 0 10.8 0H9.15C9.15 0.24 8.94 0.45 8.7 0.45C8.46 0.45 8.25 0.24 8.25 0H1.2C0.54 0 1.40625e-08 0.54 0 1.2V3.3C0.66 3.3 1.2 3.84 1.2 4.5C1.2 5.16 0.66 5.7 0 5.7V7.8C0 8.46 0.54 9 1.2 9H8.25C8.25 8.76 8.46 8.55 8.7 8.55C8.94 8.55 9.15 8.76 9.15 9H10.8C11.46 9 12 8.46 12 7.8V5.7C11.34 5.7 10.8 5.16 10.8 4.5C10.8 3.84 11.34 3.3 12 3.3ZM8.7 7.95C8.46 7.95 8.25 7.74 8.25 7.5C8.25 7.26 8.46 7.05 8.7 7.05C8.94 7.05 9.15 7.26 9.15 7.5C9.15 7.74 8.94 7.95 8.7 7.95ZM8.7 6.45C8.46 6.45 8.25 6.24 8.25 6C8.25 5.76 8.46 5.55 8.7 5.55C8.94 5.55 9.15 5.76 9.15 6C9.15 6.24 8.94 6.45 8.7 6.45ZM8.7 4.95C8.46 4.95 8.25 4.74 8.25 4.5C8.25 4.26 8.46 4.05 8.7 4.05C8.94 4.05 9.15 4.26 9.15 4.5C9.15 4.74 8.94 4.95 8.7 4.95ZM8.7 3.45C8.46 3.45 8.25 3.24 8.25 3C8.25 2.76 8.46 2.55 8.7 2.55C8.94 2.55 9.15 2.76 9.15 3C9.15 3.24 8.94 3.45 8.7 3.45ZM8.7 1.95C8.46 1.95 8.25 1.74 8.25 1.5C8.25 1.26 8.46 1.05 8.7 1.05C8.94 1.05 9.15 1.26 9.15 1.5C9.15 1.74 8.94 1.95 8.7 1.95Z",
    fill: "#848A9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticketIcon.afdeea562b6f129d0e11fe9dc3a7c88a.svg";
export { ForwardRef as ReactComponent };